import React from "react";

const CommonTotalBlock = ({ fantasyPointsData }) => {
  return (
    <>
      <div className="container">
        <ul>
          <li>
            <div className="countbox">
              <strong>{fantasyPointsData?.sum_rs}</strong>
              <span> Runs</span>
            </div>
          </li>

          <li>
            <div className="countbox">
              <strong>{fantasyPointsData?.sum_fours}</strong>
              <span> Fours</span>
            </div>
          </li>

          <li>
            <div className="countbox">
              <strong>{fantasyPointsData?.sum_sixes}</strong>
              <span> Sixes</span>
            </div>
          </li>

          <li>
            <div className="countbox">
              <strong>{fantasyPointsData?.sum_overs}</strong>
              <span>Overs</span>
            </div>
          </li>
          <li>
            <div className="countbox">
              <strong>{fantasyPointsData?.sum_mdns}</strong>
              <span>Maidens</span>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default CommonTotalBlock;
